export default (arr: any [], value: any) => {
  const idIndex = arr.indexOf(value)

  return [
    ...arr.slice(0, idIndex),
    ...arr.slice(idIndex + 1)
  ]
}



// WEBPACK FOOTER //
// ./src/utils/remove.tsx